var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4425 10.125H14.25V6.375C14.25 5.9625 13.9125 5.625 13.5 5.625H10.5C10.0875 5.625 9.75 5.9625 9.75 6.375V10.125H8.5575C7.89 10.125 7.5525 10.935 8.025 11.4075L11.4675 14.85C11.76 15.1425 12.2325 15.1425 12.525 14.85L15.9675 11.4075C16.44 10.935 16.11 10.125 15.4425 10.125ZM6.75 17.625C6.75 18.0375 7.0875 18.375 7.5 18.375H16.5C16.9125 18.375 17.25 18.0375 17.25 17.625C17.25 17.2125 16.9125 16.875 16.5 16.875H7.5C7.0875 16.875 6.75 17.2125 6.75 17.625Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadicon);
export default __webpack_public_path__ + "static/media/downloadicon.d97373156b5a3102eb2ab68185545ab5.svg";
export { ForwardRef as ReactComponent };